import _extends from "@babel/runtime-corejs3/helpers/extends";

var _context;

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { colors, widths, textAlignments, positions } from "../../../enums";
import { toUIProps } from "../../../util";
import { removeProps, whitelistStyles } from "../hoc";
import { compose } from 'react-recompose';
import classnames from 'classnames';
import IsInvertedProvider from "../../abstractions/is-inverted-provider";
import { GridColumn as UIGridColumn } from 'semantic-ui-react';
var ADDED_PROPS = ['backgroundColor', 'columnStyles', 'columnWidth', 'float', '_parentColumnStyles', 'isContentCentered', 'isInverted'];
var MODIFIED_PROPS = [];
var UNSUPPORTED_PROPS = ['as', 'color', 'className', 'computer', 'floated', 'largeScreen', 'mobile', 'tablet', 'widescreen', 'width', 'only'];
var propMap = {
  "float": 'floated'
};
var LayoutColumn = createComponent({
  displayName: 'LayoutColumn',
  propTypes: {
    children: PropTypes.node,
    backgroundColor: PropTypes.oneOf(_concatInstanceProperty(_context = []).call(_context, colors.CORE, ['transparent'])),
    columnWidth: PropTypes.oneOfType([PropTypes.oneOf(widths.ALL), PropTypes.shape({
      mobile: PropTypes.oneOf(widths.ALL),
      tablet: PropTypes.oneOf(widths.ALL),
      computer: PropTypes.oneOf(widths.ALL),
      largeScreen: PropTypes.oneOf(widths.ALL),
      widescreen: PropTypes.oneOf(widths.ALL)
    })]),
    "float": PropTypes.oneOf(positions.LR),
    isInverted: PropTypes.bool,
    textAlign: PropTypes.oneOf(textAlignments.ALL),
    verticalAlign: PropTypes.oneOf(positions.alignColumns.ALL),
    isContentCentered: PropTypes.bool,
    _parentColumnStyles: PropTypes.shape({
      backgroundColor: PropTypes.oneOf(colors.CORE),
      "float": PropTypes.oneOf(positions.LR),
      isInverted: PropTypes.bool,
      textAlign: PropTypes.oneOf(textAlignments.ALL),
      verticalAlign: PropTypes.oneOf(positions.alignColumns.ALL),
      isContentCentered: PropTypes.bool
    })
  },
  defaultProps: {
    children: undefined,
    columnWidth: null,
    backgroundColor: undefined,
    "float": undefined,
    isInverted: undefined,
    //Gets merged with context value which provides the default value
    textAlign: undefined,
    verticalAlign: undefined,
    isContentCentered: undefined,
    _parentColumnStyles: {}
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var _classnames;

    var columnStyles = getColumnStyles(p._parentColumnStyles, p);

    var props = _Object$assign({}, p, columnStyles);

    if (columnStyles.verticalAlign === positions.alignColumns.FLEX) {
      props.verticalAlign = null;
      props.stretched = true;
    } else {
      props.verticalAlign = columnStyles.verticalAlign;
      props.stretched = false;
    }

    logger.warn("HEADS UP, you passed a margin style to <Layout.Column>,\n      which will cause columns to wrap to new rows unexpectingly,\n      did you mean to pass padding instead? Or did you hit a use\n      case to warrant deleting this warning?", !!props.style && !!props.style.margin);
    var UIProps = toUIProps({
      props: props,
      propMap: propMap,
      ADDED_PROPS: ADDED_PROPS,
      MODIFIED_PROPS: MODIFIED_PROPS,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS
    });
    delete UIProps.children;
    UIProps = _Object$assign({}, UIProps, mapColumns(p));
    UIProps.className = classnames((_classnames = {}, _classnames[props.backgroundColor] = props.backgroundColor !== 'transparent', _classnames.inverted = props.isInverted, _classnames['centered-content'] = props.isContentCentered, _classnames));
    /*
      Need the provider here to ensure children have a matching inverted state
    */

    return /*#__PURE__*/React.createElement(IsInvertedProvider, {
      isInverted: props.isInverted
    }, /*#__PURE__*/React.createElement(UIGridColumn, UIProps, props.children));
  }
}); // Don't want to set these as defaultProps because then we can't determine if they were set by the user or not

var defaultColumnStyles = {
  backgroundColor: 'transparent',
  //transparent grid by default
  "float": null,
  textAlign: null,
  verticalAlign: positions.alignColumns.TOP,
  isContentCentered: false
};

function getColumnStyles(parent, overrides) {
  var columnStyles = _Object$assign({}, defaultColumnStyles, parent);

  return _.mapValues(columnStyles, function (value, key) {
    return getDefaultOrOverrideVal(value, overrides[key]);
  });
}

function getDefaultOrOverrideVal(defaultVal, overrideVal) {
  return overrideVal === undefined ? defaultVal : overrideVal;
}

function mapColumns(_ref) {
  var columnWidth = _ref.columnWidth;

  if (!!columnWidth) {
    return _extends({}, typeof columnWidth === 'string' && {
      width: columnWidth
    }, columnWidth.mobile && {
      mobile: columnWidth.mobile
    }, columnWidth.tablet && {
      tablet: columnWidth.tablet
    }, columnWidth.computer && {
      computer: columnWidth.computer
    }, columnWidth.largeScreen && {
      largeScreen: columnWidth.largeScreen
    }, (columnWidth.widescreen || columnWidth.wideScreen) && {
      widescreen: columnWidth.widescreen || columnWidth.wideScreen
    });
  } else return columnWidth;
}

export var PrivateLayoutColumn = whitelistStyles(['display', 'alignItems', 'alignContent', 'flexDirection', 'flexWrap', 'justifyContent'])(LayoutColumn);
export default removeProps(['_parentColumnStyles'])(PrivateLayoutColumn);
//# sourceMappingURL=layout-column.js.map